import {
  createInitialDataLayer,
  type DataLayer,
  type DataLayerData,
  PageType,
} from '@redteclab/gtm-datalayer-library'

import {
  SHOP_ENV,
  type TENANT,
  type TENANT_AND_ENV,
  TENANT_AND_ENV_TO_HOST,
  tenantToLocaleRegionMap,
} from '../../tenant'
import { GTM_CONST_APPLICATION_NAME } from '../GTM_CONST'

/**
 * We are currently using the same data layer structure as the old cart intermediate page.
 * To ensure consistency, we need to build it statically—just like we did in the old cart intermediate page in Fock (as discussed with Damian Dudek).
 * Since this new cart intermediate page is replacing the old one, maintaining the same data layer format is important for testing purposes.
 * This implementation is temporary and will be refactored once the dependent services are updated.
 */
export const gtmBuildPropsForCartIntermediatePage = ({
  language,
  shopEnv,
  tenant,
  tenantAndEnv,
}: {
  language: DataLayerData['language']
  shopEnv: SHOP_ENV
  tenant: TENANT
  tenantAndEnv: TENANT_AND_ENV
}): DataLayer => {
  const shopUrl = TENANT_AND_ENV_TO_HOST[tenantAndEnv]
  const dataLayerData: DataLayerData = {
    countryCode: tenantToLocaleRegionMap[tenant],
    environment: shopEnv === SHOP_ENV.QS ? 'reference' : 'production',
    language,
    tenant: tenantAndEnv,
  }

  return createInitialDataLayer({
    application: GTM_CONST_APPLICATION_NAME,
    dataLayerData,
    pageType: PageType.CART_INTERMEDIATE,
    url: new URL(
      `https://${shopUrl}/${tenantAndEnv}/${language}/cartintermediate`,
    ),
  })
}
